import {
  EMPLOYEE_PIN_PAGE_REQUEST,
  EMPLOYEE_PIN_ON_SUBMIT_FORM,
  EMPLOYEE_PIN_PIN_REQUEST,
  SUBMITTING_GET_PERMISSIONS
} from 'actions/employees/pin/constants'
import * as actNotif from 'actions/notifications'
import {showProgressBar, hideProgressBar} from 'actions'
import {initialize} from 'redux-form'
import {takeLatest, put, call} from 'redux-saga/effects'
import {pinRequest, setSubmitting, setAllowedFields, showSaveAppPermissionModal, setSaveAppPermissionModal} from 'actions/employees/pin'
import * as apiSetting from 'api/permissions/settings'
import * as apiEmployee from 'api/employees'
import sortBy from 'lodash/sortBy'
import * as mpPin from 'mixpanel/employees/pin'

const fieldDescription = (subMenu) => {
  switch (subMenu) {
    case 'Manage Discount':
      return 'Required PIN to manage discount'
    case 'Edit Customer List':
      return 'Required PIN to edit customer'
    case 'Edit and Remove Open Bills':
      return 'Required PIN to edit and remove open bills'
    case 'Resend Receipt':
      return 'Required PIN to resend receipt'
    case 'Issue Refunds':
      return 'Required PIN to do refund payment'
    case 'Record Payment for Invoice':
      return 'Required PIN to record payment for invoice'
    case 'Cancel Invoice':
      return 'Required PIN to cancel invoice payment'
    default:
      return ''
  }
}

const fieldName = (subMenu) => {
  switch (subMenu) {
    case 'Manage Discount':
      return 'manage_discount'
    case 'Edit Customer List':
      return 'edit_customer_list'
    case 'Edit and Remove Open Bills':
      return 'edit_and_remove_open_bills'
    case 'Resend Receipt':
      return 'resend_receipt'
    case 'Issue Refunds':
      return 'issue_refunds'
    case 'Record Payment for Invoice':
      return 'record_payment_for_invoice'
    case 'Cancel Invoice':
      return 'cancel_invoice'
    default:
      return ''
  }
}

const convertToPinFieldValues = (pinSettings) => {
  const fields = {}
  pinSettings.forEach(ps => {
    fields[fieldName(ps.sub_menu)] = ps.pin_required
  })
  return fields
}

/**
 * @param permissions current user permissions
 */
export function * managePermissions ({permissions}) {
  const allowedFields = []

  permissions.forEach((p) => {
    if (p.access === 'App') {
      const data = {
        label: p.sub_menu,
        disabled: false,
        name: fieldName(p.sub_menu),
        description: fieldDescription(p.sub_menu),
        order: p.priorty_rank
      }
      switch (p.sub_menu) {
        case 'Manage Discount':
          allowedFields.push({
            ...data
          })
          break
        case 'Edit Customer List':
          allowedFields.push({
            ...data
          })
          break
        case 'Edit and Remove Open Bills':
          allowedFields.push({
            ...data
          })
          break
        case 'Resend Receipt':
          allowedFields.push({
            ...data
          })
          break
        case 'Issue Refunds':
          allowedFields.push({
            ...data
          })
          break
        case 'Record Payment for Invoice':
          allowedFields.push({
            ...data
          })
          break
        case 'Cancel Invoice':
          allowedFields.push({
            ...data
          })
          break
      }
    }
  })
  const sortedFields = sortBy(allowedFields, ['order'])
  yield put(setAllowedFields({allowedFields: sortedFields}))
}

export function * pageRequestFlow (request) {
  const {payload: {user}} = request
  yield put(pinRequest({user}))
}

export function * pinRequestFlow (request) {
  const {payload: {user}} = request
  try {
    yield put(showProgressBar())
    yield put(setSubmitting({submitting: SUBMITTING_GET_PERMISSIONS}))

    const resPermissions = yield call(apiEmployee.getPermission, {userId: user.id, params: {}})
    yield call(managePermissions, {permissions: resPermissions.data.permissions})
    const responsePin = yield call(apiSetting.getPin, {params: {}})
    const values = convertToPinFieldValues(responsePin.data.pin_settings)
    yield put(initialize('pin', {...values}))
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(setSubmitting({submitting: null}))
    yield put(hideProgressBar())
  }
}

export function * onSubmitFormFlow (request) {
  const {payload: {values}} = request

  let hasPinEnabled = false
  Object.values(values).forEach(v => { hasPinEnabled = hasPinEnabled || v })

  try {
    yield put(showProgressBar())
    const response = yield call(apiSetting.putPin, {data: values, params: {}})
    yield put(initialize('pin', {...values}))
    yield put(actNotif.success('Permission is successfully updated'))
    mpPin.savePin({pinSettings: response.data.pin_settings})
  } catch (error) {
    if (error.data && error.data.error && error.data.error.code === 10) {
      yield put(setSaveAppPermissionModal({message: error.data.error.user_message}))
      yield put(showSaveAppPermissionModal())
    } else {
      yield put(actNotif.error(error.message))
    }
  } finally {
    yield put(hideProgressBar())
  }
}

export default function * saga () {
  yield takeLatest(EMPLOYEE_PIN_PAGE_REQUEST, pageRequestFlow)
  yield takeLatest(EMPLOYEE_PIN_ON_SUBMIT_FORM, onSubmitFormFlow)
  yield takeLatest(EMPLOYEE_PIN_PIN_REQUEST, pinRequestFlow)
}



// WEBPACK FOOTER //
// ./app/sagas/employees/pin.js